/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiRequestActivityManagementV2 } from '../model/models';
import { ApiRequestConfirmModeForPossibleCommute } from '../model/models';
import { ApiRequestTripLogModel } from '../model/models';
import { ApiResponseUnseenActivityTripAndTransactionModel } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface TripManagementServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param apiRequestActivityManagementV2 
     */
    tripManagementControllerChangeModeV20(apiRequestActivityManagementV2: ApiRequestActivityManagementV2, extraHttpRequestParams?: any): Observable<ApiResponseUnseenActivityTripAndTransactionModel>;

    /**
     * 
     * 
     * @param apiRequestActivityManagementV2 
     */
    tripManagementControllerChangeModeV21(apiRequestActivityManagementV2: ApiRequestActivityManagementV2, extraHttpRequestParams?: any): Observable<ApiResponseUnseenActivityTripAndTransactionModel>;

    /**
     * 
     * 
     * @param apiRequestConfirmModeForPossibleCommute 
     */
    tripManagementControllerConfirmMode0(apiRequestConfirmModeForPossibleCommute: ApiRequestConfirmModeForPossibleCommute, extraHttpRequestParams?: any): Observable<ApiResponseUnseenActivityTripAndTransactionModel>;

    /**
     * 
     * 
     * @param apiRequestConfirmModeForPossibleCommute 
     */
    tripManagementControllerConfirmMode1(apiRequestConfirmModeForPossibleCommute: ApiRequestConfirmModeForPossibleCommute, extraHttpRequestParams?: any): Observable<ApiResponseUnseenActivityTripAndTransactionModel>;

    /**
     * 
     * 
     * @param apiRequestTripLogModel 
     */
    tripManagementControllerLogTrips0(apiRequestTripLogModel: ApiRequestTripLogModel, extraHttpRequestParams?: any): Observable<ApiResponseUnseenActivityTripAndTransactionModel>;

    /**
     * 
     * 
     * @param apiRequestTripLogModel 
     */
    tripManagementControllerLogTrips1(apiRequestTripLogModel: ApiRequestTripLogModel, extraHttpRequestParams?: any): Observable<ApiResponseUnseenActivityTripAndTransactionModel>;

}
